module.exports = __webpack_public_path__ + "static/riderlink_banner-af432249b8781feaf443f0c32c3ffef9.png";